import {Injectable} from '@angular/core'
import {Observable} from 'rxjs/Observable'

@Injectable()
export class RouterMock {

  public events = Observable.of('')

  public navigate(route){}
  public navigateByUrl(url){}
}



// WEBPACK FOOTER //
// ./src/app/shared/tests/router.mock.ts